import request from '@/utils/request';
import { downLoad } from '@/utils';

const api = '/ddp/system/';
const pyotxconvApi = '/ddp/otxconv/';
const featureApi = '/ddp/feature/';
const versionApi = '/ddp/version/';
export default {
    getIcon() {
        return request.get(`${api}getIcon`);
    },
    updateIcon(data: any) {
        return request.post(`${api}uploadIcon`, data);
    },
    getFeatureStatus() {
        return request.get(`${featureApi}getFeatureStatus`);
    },
    getOtxConvertList(params: any) {
        return request.get(`${pyotxconvApi}getOtxConvertList`, params);
    },
    uploadOtxConvertSourceFile() {
        return request.get(`${pyotxconvApi}uploadOtxConvertSourceFile`);
    },
    startOtxConvert(params: any) {
        return request.post(`${pyotxconvApi}startOtxConvert`, params);
    },
    deleteOtxConverRecorder(params: any) {
        return request.get(`${pyotxconvApi}deleteOtxConverRecorder`, params);
    },
    downloadOtxConvertResult(params: any) {
        downLoad(`${pyotxconvApi}downloadOtxConvertResult`, params);
    },
    downloadOtxConvertLog(params: any) {
        downLoad(`${pyotxconvApi}downloadOtxConvertLog`, params);
    },
    checkOtxConvertStatus(option?: any) {
        return request.get(`${pyotxconvApi}checkOtxConvertStatus`, {}, option);
    },
    status() {
        return request.get(`${pyotxconvApi}status`);
    },
    getSetting() {
        return request.get(`${versionApi}global`);
    },
    getLoginMode() {
        return request.get(`${api}auth/mode`);
    }
};
